import PropTypes from 'prop-types';
// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import UI from 'UI';

export default class NavBar extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            overflow: false,
            itemsToShow: this.props.children.length,
            expanded: false,
            measured: false,
        };
    }

    componentDidMount() {
        // subscribe to future theme changes
        // super.componentDidMount();
        // window.dispatchEvent(new Event('resize'));
        this.measure();
        this.context.screenSizeObserver.subscribe(() => {
            this.measure();
            this.forceUpdate();
        });
    }

    static contextTypes = {
        screenSizeObserver: PropTypes.object,
    };

    measure = () => {
        let el = ReactDOM.findDOMNode(this);
        let elitems = ReactDOM.findDOMNode(this.refs.items);
        let containerWidth = el.offsetWidth;
        // if (el);

        let itemsToShow = 0;
        let totalWidth = 0;

        for (var i = 0; i < elitems.children.length; i++) {
            var item = elitems.children[i];
            totalWidth += item.offsetWidth;

            if (totalWidth < containerWidth) {
                itemsToShow++;
            }
        }

        if (itemsToShow === 0) itemsToShow = 1;

        this.setState({
            overflow: itemsToShow !== elitems.children.length,
            itemsToShow,
            measured: true,
        });
        // var widthitems = ReactDOM.findDOMNode(this.refs.items).offsetWidth;
        // console.log("WIDTH", width, widthitems)
    };

    render() {
        let { overflow, itemsToShow, expanded, measured } = this.state;
        let media = this.context.screenSizeObserver;
        return (
            <div className={cx(this.props.className, 'wdp-nav wdp-nav-tabs wdp-nav-bar')}>
                <ul className="wdp-nav-bar__shadow" ref="items">
                    {this.props.children}
                </ul>

                {
                    <ul className="wdp-nav-bar__list" onClick={() => this.setState({ expanded: false })}>
                        {measured ? (
                            _.take(this.props.children, itemsToShow)
                        ) : (
                            <li>
                                <a>{UI.nbsp}</a>
                            </li>
                        )}
                    </ul>
                }
                {expanded && (
                    <ul className="wdp-nav-bar__popup" onClick={() => this.setState({ expanded: false })}>
                        {false && _.takeRight(this.props.children, this.props.children.length - itemsToShow)}
                        {this.props.children}
                    </ul>
                )}
                {overflow && <UI.DropdownIcon onClick={() => this.setState({ expanded: !this.state.expanded })} />}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/NavBar.js
 **/